'use strict';

module.exports = require('react/lib/ReactDOM');



/** WEBPACK FOOTER **
 ** ./~/react-dom/index.js
 **/